var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { UpdateCharacter } from "Server/Commands/UpdateCharacter";
import { GetAttributes } from "Store/firebase/attributes";
import { Attribute } from "Store/firebase/attributes/@Attribute";
import { AttributeEditorUI } from "UI/Write/AttributeDetailsUI";
import { GetErrorMessagesUnderElement, Clone } from "js-vextensions";
import { Button, CheckBox, Column, Div, Pre, Row, RowLR, TextArea, TextInput, Spinner } from "react-vcomponents";
import { BaseComponent, GetInnerComp } from "react-vextensions";
import { ShowMessageBox } from "react-vmessagebox";
import { Slider, Observer } from "vwebapp-framework";
import { AddAttribute } from "../../Server/Commands/AddAttribute";
import { AddCharacter } from "../../Server/Commands/AddCharacter";
import { Character } from "../../Store/firebase/characters/@Character";
let CharacterDetailsUI = class CharacterDetailsUI extends BaseComponent {
    ComponentWillMountOrReceiveProps(props, forMount) {
        if (forMount || props.baseData != this.props.baseData) { // if base-data changed
            this.SetState({ newData: Clone(props.baseData) });
        }
    }
    render() {
        const { baseData, forNew, enabled, style, onChange } = this.props;
        const attributes = GetAttributes();
        const { newData } = this.state;
        //const creator = !forNew && GetUser(baseData.creator);
        const Change = _ => {
            if (onChange)
                onChange(this.GetNewData(), this);
            this.Update();
        };
        const splitAt = 170;
        const width = 600;
        return (React.createElement(Column, { style: style },
            React.createElement(RowLR, { mt: 5, splitAt: splitAt, style: { width } },
                React.createElement(Pre, null, "Name: "),
                React.createElement(TextInput, { required: true, delayChangeTillDefocus: true, enabled: enabled, style: { width: "100%" }, value: newData.name, onChange: val => {
                        if (forNew) {
                            Change(newData.name = val);
                        }
                        else {
                            new UpdateCharacter({ id: baseData._key, updates: { name: val } }).Run();
                        }
                    } })),
            React.createElement(RowLR, { mt: 5, splitAt: splitAt, style: { width } },
                React.createElement(Pre, null, "Note: "),
                React.createElement(TextInput, { delayChangeTillDefocus: true, enabled: enabled, style: { width: "100%" }, value: newData.note, onChange: val => {
                        if (forNew) {
                            Change(newData.note = val);
                        }
                        else {
                            new UpdateCharacter({ id: baseData._key, updates: { note: val } }).Run();
                        }
                    } })),
            React.createElement(RowLR, { mt: 5, splitAt: splitAt, style: { width } },
                React.createElement(Pre, null, "Description: "),
                React.createElement(TextArea, { delayChangeTillDefocus: true, editable: enabled, style: { width: "100%", whiteSpace: "" }, value: newData.description, onChange: val => {
                        if (forNew) {
                            Change(newData.description = val);
                        }
                        else {
                            new UpdateCharacter({ id: baseData._key, updates: { description: val } }).Run();
                        }
                    } })),
            React.createElement(RowLR, { mt: 5, splitAt: splitAt, style: { width } },
                React.createElement(Pre, null, "Level: "),
                React.createElement(Spinner, { step: 1, min: 1, max: 100, style: { minWidth: 0 }, value: newData.level, onChange: val => {
                        if (forNew) {
                            Change(newData.level = val);
                        }
                        else {
                            new UpdateCharacter({ id: baseData._key, updates: { level: val } }).Run();
                        }
                    } })),
            !forNew
                && [
                    React.createElement(Row, { key: 1 },
                        React.createElement(Pre, null, "Attributes: "),
                        React.createElement(Button, { text: "+", onClick: () => {
                                const attribute = new Attribute({ name: "todo" });
                                new AddAttribute({ attribute }).Run();
                            } })),
                    React.createElement(Column, { key: 2 }, attributes.map(attr => {
                        const hasAttribute = (newData.attributeLevels || {})[attr._key] != null;
                        return (React.createElement(Row, { key: attr._key },
                            React.createElement(AttributeEditorUI, { mt: 5, attribute: attr }),
                            React.createElement(Div, { ml: 10, mr: 10, style: { width: 200 } },
                                React.createElement(Slider, { min: 0, max: 1, step: .1, enabled: hasAttribute, delayChangeTillDefocus: true, value: (newData.attributeLevels || {})[attr._key], onChange: val => {
                                        const newAttributeLevels = Clone(newData.attributeLevels || {});
                                        newAttributeLevels[attr._key] = val;
                                        new UpdateCharacter({ id: baseData._key, updates: { attributeLevels: newAttributeLevels } }).Run();
                                    } })),
                            React.createElement(CheckBox, { value: hasAttribute, onChange: val => {
                                    const newAttributeLevels = Clone(newData.attributeLevels || {});
                                    if (val)
                                        newAttributeLevels[attr._key] = 0;
                                    else
                                        delete newAttributeLevels[attr._key];
                                    new UpdateCharacter({ id: baseData._key, updates: { attributeLevels: newAttributeLevels } }).Run();
                                } })));
                    })),
                ]));
    }
    GetValidationError() {
        return GetErrorMessagesUnderElement(this.DOM)[0];
    }
    GetNewData() {
        const { newData } = this.state;
        return Clone(newData);
    }
};
CharacterDetailsUI = __decorate([
    Observer
], CharacterDetailsUI);
export { CharacterDetailsUI };
export function ShowAddCharacterDialog(userID, bookID) {
    let newCharacter = new Character({ name: "", book: bookID });
    let detailsUI;
    let error = null;
    const Change = (..._) => boxController.UpdateUI();
    let boxController = ShowMessageBox({
        title: "Add character", cancelButton: true,
        message: () => {
            boxController.options.okButtonProps = { enabled: error == null };
            return (React.createElement(Column, { style: { padding: "10px 0", width: 600 } },
                React.createElement(CharacterDetailsUI, { ref: c => detailsUI = GetInnerComp(c), baseData: newCharacter, forNew: true, onChange: val => Change(newCharacter = val, error = detailsUI.GetValidationError()) }),
                error && error != "Please fill out this field." && React.createElement(Row, { mt: 5, style: { color: "rgba(200,70,70,1)" } }, error)));
        },
        onOK: () => {
            new AddCharacter({ character: newCharacter }).Run();
        },
    });
}
